import { pushFile } from '../../../State/files'

export default (file) => (dispatch) => {

  dispatch(pushFile(file))

  return false

}